//@ts-check
"use strict";

const { preventCloseOnClickInsideDropdown, getQuickAccessItems, getScrollSizeForPopper } = require("./helpers");
const QFavoriteButton = require("./q-favorite-button");
const { effect, computed } = require('@node_modules/@preact/signals-core');
const KTLayoutHeader = require("../base/header");
const KTLayoutSubheader = require("../base/subheader");

function QBreadcrumbQuickAccess(sections, options) {
    const quickAccessEl = $(/*html*/`
        <li class="breadcrumb-item">
            <div class="dropdown dropdown-inline">
                <a 
                    class="btn btn-sm dropdown-toggle py-2 px-1"
                    data-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="true"
                >
                    <svg width="24" height="24" viewBox="0 0 42 42" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M29.1661 18.3918L29.026 16.2068C28.9471 14.9772 28.8692 13.7487 28.7924 12.5212C27.5153 14.2182 26.2363 15.9171 24.9554 17.6179L24.2733 18.5235L23.1465 18.6479C20.8361 18.9029 18.5241 19.158 16.2104 19.413C17.1574 20.8494 18.1095 22.2832 19.0667 23.7144L19.9541 25.0412L19.1844 26.4396C18.4306 27.809 17.6763 29.1785 16.9214 30.5479C18.2681 29.8631 19.6142 29.1778 20.9599 28.4919L22.4542 27.7302L23.7733 28.7662C25.095 29.8042 26.4203 30.8399 27.7491 31.8731C28.0666 29.5248 28.3873 27.1765 28.7112 24.8282L28.8625 23.7314L29.7536 23.0742C31.5514 21.7484 33.3471 20.4214 35.1406 19.0934C33.8728 18.9431 32.6062 18.7939 31.3408 18.646L29.1661 18.3918ZM38.2127 16.8159C39.474 16.9669 40.7364 17.1191 42 17.2725C40.9799 18.0309 39.9591 18.789 38.9376 19.5467C36.4 21.429 33.8579 23.309 31.3116 25.1869C30.9187 28.0352 30.5306 30.8836 30.1471 33.732C30.0123 34.7336 29.878 35.7352 29.7443 36.7369C28.9429 36.1194 28.1429 35.501 27.344 34.8818C25.6073 33.5355 23.8766 32.1851 22.1519 30.8306C19.658 32.1018 17.1624 33.3711 14.6649 34.6386C13.2772 35.343 11.8889 36.0468 10.5 36.75C11.2529 35.3877 12.0052 34.0255 12.757 32.6632C14.1347 30.1667 15.5106 27.6702 16.8848 25.1737C15.6752 23.3653 14.4738 21.5527 13.2804 19.7359C12.7417 18.9156 12.2045 18.0945 11.669 17.2725C12.6441 17.1651 13.6189 17.0577 14.5934 16.9503C17.3508 16.6465 20.1058 16.3426 22.8585 16.0388C24.7575 13.5171 26.6524 10.9998 28.543 8.48669C29.3553 7.407 30.1668 6.32811 30.9776 5.25C31.0579 6.59605 31.1394 7.94333 31.2222 9.29185C31.36 11.5374 31.5011 13.7864 31.6456 16.0388C33.8312 16.2943 36.0202 16.5533 38.2127 16.8159Z" fill="#1E1E24"/>
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M15.75 13.125H0V10.5H15.75V13.125Z" fill="#1E1E24"/>
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M7.875 23.625H0V21H7.875V23.625Z" fill="#1E1E24"/>
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M5.25 34.125H0V31.5H5.25V34.125Z" fill="#1E1E24"/>
                    </svg>
                </a>
                <div class="dropdown-menu dropdown-menu-left p-0" x-placement="bottom-end" style="width: calc(45vw + 16px); max-width: 800px">
                    <div class="card-body p-0">
                        <div class="card card-custom quick-access show-limited">
                            <div class="card-header card-header-tabs-line px-4 mt-3">
                                <div class="card-toolbar">
                                    <ul class="nav nav-tabs nav-bold nav-tabs-line nav-tabs-line-3x" role="tablist"></ul>
                                </div>
                                <div class="card-toolbar">
                                    <a href="#" class="btn btn-link-primary text-primary font-weight-bolder show-less-items">
                                        ver menos
                                        <i class="las la-times"></i>
                                    </a>
                                </div>
                            </div>
                            <div class="card-body pt-8 pb-4 px-4">
                                <div class="tab-content"></div>
                            </div>
                        </div>
                    </div> 
                </div>
            </div>
        </li>
    `);

    fixPopperPosition(quickAccessEl);
    preventCloseOnClickInsideDropdown(quickAccessEl.find('.dropdown'))

    quickAccessEl.on('click', 'a.show-less-items', (event) => {
        event.preventDefault();

        quickAccessEl
            .find('.card')
            .removeClass('show-all')
            .addClass('show-limited');
    });

    const recents = buildTabQuickAccess(sections, {
        caption: 'Recentes',
        uuid: uuidv4().replace(/-/g, '_'),
        itemCondition: (item) => item._isRecent.value,
        itemSort: (a, b) => ((a.recentOrder || 0) - (b.recentOrder || 0)),
        isActive: true,
        dispatchEvent: options.dispatchEvent,
    });

    const favorites = buildTabQuickAccess(sections, {
        caption: 'Favoritos',
        uuid: uuidv4().replace(/-/g, '_'),
        itemCondition: (item) => item._isFavorite.value,
        dispatchEvent: options.dispatchEvent
    });

    quickAccessEl.find('.tab-content').append([recents.tabContent, favorites.tabContent]);
    quickAccessEl.find('.card-toolbar .nav.nav-tabs').append([recents.tabLink, favorites.tabLink]);

    recents.tabContent.find('.show-more-items').remove();

    recents.tabLink
        .find('[data-toggle=tab]')
        .on('shown.bs.tab', () => quickAccessEl.find('.show-less-items').css('display', 'none'))
        .on('hide.bs.tab', () => quickAccessEl.find('.show-less-items').css('display', ''));

    return quickAccessEl;
}

function buildTabQuickAccess(sections, options) {
    const tabContent = $(/*html*/`
        <div class="tab-pane fade ${options.isActive ? 'active show' : ''}" id="tab_${options.uuid}" role="tabpanel">
            <ul class="navi navi-hover column-grid-3 custom-scrollbar"></ul>
        </div>
    `);

    const tabLink = $(/*html*/`
        <li class="nav-item">
            <a class="nav-link px-8 py-2 m-0 justify-content-center ${options.isActive ? 'active' : ''}" data-toggle="tab" href="#tab_${options.uuid}">
                <span class="nav-text">${options.caption}</span>
            </a>
        </li>
    `);

    const items = computed(() => getQuickAccessItems(sections, options.itemCondition, options.itemSort));
    
    effect(() => {
        const listEl = buildItems(items.value, { useTooltip: true, dispatchEvent: options.dispatchEvent });
        
        tabContent.find('ul.navi').empty().append(listEl);
    })

    return {
        tabLink,
        tabContent,
    };
}

function buildItems(items, options) {
    const showMoreButton = buildShowMoreButton();
    const menuItems = items.map((item) => itemTemplate(item, options));

    showMoreButton
        .find('.navi-text')
        .text('VER TODOS...')
        .addClass('text-primary');

    showMoreButton
        .find('i')
        .remove()

    menuItems.push(showMoreButton);

    return menuItems;
}

function buildShowMoreButton() {
    const item = itemTemplate({
        href: '',
        icon: 'la-ellipsis-h',
        caption: 'VER TODOS'
    });

    item.find('.navi-label').remove();

    return item
        .addClass('show-more-items')
        .on('click', (event) => {
            event.preventDefault();

            item
                .closest('.card')
                .addClass('show-all')
                .removeClass('show-limited');
        });
}

function itemTemplate(item, options) {
    const itemEl = $(/*html*/ `
        <li class="navi-item">
            <a class="navi-link${item.isActive ? ' active' : ''} h-100" href="${item.href}">
                <span class="navi-icon">
                    <i class="las ${item.icon ? item.icon : 'la-folder-open icon-default'} text-primary"></i>
                </span>
                <span class="navi-text">${item.caption}</span>
                <span class="navi-label"></span>
            </a>
        </li>
    `);

    itemEl
        .find('.navi-label')
        .append(QFavoriteButton({
            item: item,
            onClick: (event) => {
                if (typeof options.dispatchEvent == 'function') {
                    options.dispatchEvent({
                        type: 'favorite-click',
                        originalEvent: event,
                        item: item,
                        isFavorite: $(event.currentTarget).find('i').hasClass('la-star'),
                    });
                }
            },
        }));

    if ((options || {}).useTooltip) {
        itemEl
            .find('a.navi-link')
            .tooltip({
                placement: 'left',
                title: item.path,
                container: itemEl
            })
            .on('mouseleave', (event) => {
                const tooltip = $(event.currentTarget).data('bs.tooltip');

                if (tooltip) tooltip.hide();
            });
    }

    return itemEl;
}


function fixPopperPosition(quickAccessEl) {
    quickAccessEl
        .find('[data-toggle="dropdown"]')
        .data('popperConfig', {
            positionFixed: true,
            modifiers: {
                preventOverflow: {
                    enabled: true,
                    boundariesElement: 'viewport',
                },
                flip: {
                    enabled: false,
                },
                offset: {
                    enabled: true,
                    fn: (data) => {
                        const headerSize = KTLayoutHeader.getHeight() + KTLayoutSubheader.getHeight();
                        const offsets = data.offsets
                        const offsetTop = Math.ceil(offsets.reference.top + offsets.reference.height);
                        const top = offsetTop < headerSize ? headerSize : offsetTop;

                        data.styles = {
                            ...data.styles,
                            transform: `translate3d(${offsets.popper.left}px, ${top}px, 0px)`,
                            overflowY: 'hidden',
                        };

                        $('.custom-scrollbar', quickAccessEl).each((index, el) => {
                            const tab = $(el).closest('[role="tabpanel"]');
                            const tabHeaderHeight = $(el).closest('.card').find('.card-header').outerHeight(true);

                            $(el).css(getScrollSizeForPopper({
                                offsetTop: `${top}px`,
                                spacingBottom: '6px', // margin between dropdown and inferior toolbar
                                marginBottom: '52px', // inferior toolbar height
                                useMinHeight: true,
                                sizes: [
                                    `${tabHeaderHeight}px`,
                                    $(quickAccessEl).find('[role="tablist"]').css('margin-top'),
                                    tab.closest('.card-body').css('padding-top'),
                                    tab.closest('.card-body').css('padding-bottom')
                                ]
                            }));
                        });

                        return data;
                    }
                }
            },
        });
}

// Webpack support
if (typeof module !== 'undefined') {
    module.exports = QBreadcrumbQuickAccess;
}
